// import React from "react";

// function CardInfo({ title, description, Icon }) {
//   return (
//     <div
//       className="group container
//       bg-[#fafafa] border border-[#d0d0d0] rounded-2xl shadow-md
//       mt-8 mb-8 w-72 md:w-96 min-h-[380px] mx-4 p-6 text-gray-900
//       hover:bg-secondary-color hover:text-white transition-all duration-300
//       hover:shadow-2xl hover:scale-[1.04]"
//     >
//       {/* Icon + Title */}
//       <div className="flex flex-col items-center text-center mt-2">
//         <div
//           className="w-24 h-24 rounded-full
//           bg-icon-bg-blue text-white
//           flex items-center justify-center shadow-md
//           transition-all duration-300
//           group-hover:bg-primary-color group-hover:text-white"
//         >
//           <Icon size={38} strokeWidth={1.5} />
//         </div>

//         <h3 className="mt-4 text-lg md:text-xl font-semibold tracking-wide">
//           {title}
//         </h3>
//       </div>

//       {/* Divider */}
//       <hr className="mt-5 mb-4 h-px bg-gray-500 group-hover:bg-white border-0 transition-all duration-300" />

//       {/* Description */}
//       <div className="px-2 text-center text-sm md:text-base leading-relaxed">
//         <p>{description}</p>
//       </div>
//     </div>
//   );
// }

// export default CardInfo;
import React from "react";

function CardInfo({ title, description, Icon }) {
  return (
    <div
      className="group container 
      backdrop-blur-xl bg-secondary-color/25 border border-white/20 
      rounded-2xl shadow-[0_8px_35px_rgba(0,0,0,0.25)]
      mt-8 mb-8 w-72 md:w-96 min-h-[380px] mx-4 p-6 text-white
      hover:bg-secondary-color/55 hover:shadow-[0_0_35px_#9b81ff60] 
      hover:scale-[1.04] transition-all duration-300"
    >
      {/* Icon + Title */}
      <div className="flex flex-col items-center text-center mt-2">
        <div
          className="w-24 h-24 rounded-full 
          bg-white/20 border border-white/30 
          backdrop-blur-lg text-white shadow-md
          flex items-center justify-center
          transition-all duration-300
          group-hover:bg-white/30 group-hover:border-white/40"
        >
          <Icon size={38} strokeWidth={1.5} />
        </div>

        <h3 className="mt-4 text-lg md:text-xl font-semibold tracking-wide text-white">
          {title}
        </h3>
      </div>

      {/* Divider */}
      <hr className="mt-5 mb-4 h-px bg-white/30 group-hover:bg-white/70 border-0 transition-all duration-300" />

      {/* Description */}
      <div className="px-2 text-center text-sm md:text-base leading-relaxed text-white/80 group-hover:text-white">
        <p>{description}</p>
      </div>
    </div>
  );
}

export default CardInfo;
